import React, { useContext, useEffect } from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';
import {
    getAnEntityReportsAction,
    getEntityChoices
} from '../../../redux/EntityReport/EntityReportAction';
import { useDispatch, useSelector } from 'react-redux';
import { getFullDateTimeConcatenated } from '../../../utils/dateTimeUtil';
import MessagesContext from '../../../contexts/messagesContext';
import ReportItem from './reportItem';
import { createLoadingSelector } from '../../../redux/Loading/LoadingSelector';
import { GET_ENTITY_CHOICES } from '../../../redux/EntityReport/EntityType';

const useStyles = makeStyles((theme) => ({
    container: {
        // height: '100%',
        [theme.breakpoints.up(1025)]: {
            minHeight: '240px',
            backgroundColor: 'white',
            marginBottom: '24px',
            padding: '24px',
            // margin: '0px 20px',
            borderRadius: '6px',
            position: 'relative',
            // width: '380px',
            borderSpacing: '10px'
        }
    },
    row: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        gridRowGap: '35px',
        gridColumnGap: '81px',
        [theme.breakpoints.down(1025)]: {
            gridTemplateColumns: '1fr ',
            gridColumnGap: '0'
        }
    },
    column: {
        [theme.breakpoints.up(1025)]: {
            display: 'flex',
            flexDirection: 'column',
            height: '100px',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
        }
    },
    header: {
        fontFamily: 'inherit',
        fontSize: '15px',
        fontWeight: 'bold',
        lineHeight: '1.75',
        letterSpacing: 'normal',
        color: '#3d454a',
        marginBottom: '32px',
        [theme.breakpoints.down(1025)]: {
            display: 'none'
        }
    },
    iconContainer: {
        // width: '17.7px',
        // height: '17.7px'
    },
    reportBtn: {
        borderRadius: '6px'
        // '& img': {
        //     margin: '0px 10px'

        // }
    },
    fixedBtnContainer: {
        position: 'fixed',
        left: '55px',
        bottom: '50px'
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    progress: {
        color: '#063f5e'
    }
}));
const DownloadReports = () => {
    const { messages } = useContext(MessagesContext);
    const classes = useStyles();
    const dispatch = useDispatch();
    const choices = useSelector((state) => state.entityReport?.entityChoices);
    const loadingSelector = createLoadingSelector(GET_ENTITY_CHOICES.REQUEST);
    const isLoading = useSelector(loadingSelector);

    // get options Dynamic !!! the endPoint /entity/choices currently
    // does not send thes types!

    useEffect(() => {
        dispatch(getEntityChoices());
    }, []);

    // sample data
    // const downloadOptions = [
    //     { key: 'patient', title: 'لیست بیماران' },
    //     { key: 'admissions', title: 'لیست پذیرش ها' },
    //     { key: 'report-graphy', title: 'گزارش گرافی' },
    //     { key: 'lab', title: 'گزارش آزمایشکاه' }
    // ];
    const getEntityExport = async (item) => {
        const blobFileAsAnURL = await dispatch(getAnEntityReportsAction(item));
        if (blobFileAsAnURL) {
            const a = document.createElement('a');
            a.href = blobFileAsAnURL;
            a.download = 'report_' + getFullDateTimeConcatenated(new Date());
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };

    return (
        <div className={classes.container}>
            <h3 className={classes.header}>{messages.reports}</h3>

            {isLoading && choices === null ? (
                <div className={classes.progressContainer}>
                    <CircularProgress className={classes.progress} />
                </div>
            ) : !choices?.length ? (
                <>
                    <div className={classes.progressContainer}>
                        <span>{messages.noReport}</span>
                    </div>
                </>
            ) : (
                <div className={classes.row}>
                    <div className={classes.column}>
                        {choices?.map((item) => (
                            <ReportItem
                                key={item.key}
                                item={item}
                                getEntityExport={() => getEntityExport(item)}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DownloadReports;
